<script lang="ts">
  import { createEventDispatcher } from 'svelte';
  import type { FormEventHandler } from 'svelte/elements';
  import debounce from 'lodash/debounce';
  import SearchIcon from '$components/Icons/Search.svelte';
  import { Input } from '$components/BlockInput';
  import FontSizeDecorator from '$components/SanityComponents/PortableText/Decorators/FontSizeDecorator.svelte';

  interface Props {
    value?: string;
    debounceChangesForMS?: number;
  }

  let { value = $bindable(''), debounceChangesForMS = 500 }: Props = $props();

  const dispatch = createEventDispatcher();

  const debouncedChange = debounce((newValue: string) => {
    dispatch('change', newValue);
  }, debounceChangesForMS);

  const handleValueChange: FormEventHandler<HTMLInputElement> = (event) => {
    value = event.currentTarget.value;

    debouncedChange(value);
  };
</script>

<FontSizeDecorator size="normal">
  <Input
    type="search"
    id="search-input"
    {value}
    oninput={handleValueChange}
    placeholder="Search roles"
    showClear={true}
    data-testid="search-input"
  >
    {#snippet icon()}
      <SearchIcon />
    {/snippet}
  </Input>
</FontSizeDecorator>
